import type { Permission } from '@vmc/shared';
import {
  BookOpen,
  FileText,
  LayoutDashboard,
  Map,
  Megaphone,
  MessagesSquare,
  ScrollText,
  Settings,
  ShieldCheck,
  Users,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  permission: Permission;
  /** Live counter shown next to the label. */
  badge?: 'queuedChats';
}

export const NAV_SECTIONS: { title?: string; items: NavItem[] }[] = [
  {
    items: [
      { to: '/', label: 'Dashboard', icon: LayoutDashboard, permission: 'dashboard:view' },
      {
        to: '/chats',
        label: 'Chats',
        icon: MessagesSquare,
        permission: 'chats:handle',
        badge: 'queuedChats',
      },
      { to: '/citizens', label: 'Citizens', icon: Users, permission: 'citizens:read' },
      { to: '/broadcasts', label: 'Broadcasts', icon: Megaphone, permission: 'broadcasts:read' },
      { to: '/templates', label: 'Templates', icon: FileText, permission: 'templates:read' },
      { to: '/kb', label: 'Knowledge base', icon: BookOpen, permission: 'kb:read' },
    ],
  },
  {
    title: 'Administration',
    items: [
      { to: '/divisions', label: 'Zones & wards', icon: Map, permission: 'divisions:write' },
      { to: '/users', label: 'Admin users', icon: ShieldCheck, permission: 'users:manage' },
      { to: '/settings', label: 'Bot settings', icon: Settings, permission: 'settings:manage' },
      { to: '/audit', label: 'Audit log', icon: ScrollText, permission: 'audit:read' },
    ],
  },
];
